import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  txt: {
    fontFamily: 'Roboto',
    color: '#333',
    fontSize: 13,
    lineHeight: 1.6,
    letterSpacing: 0,
  },
});

export default function ImportantCode(props) {
  const {
    code,
  } = props;

  const classes = useStyles();

  const getAction = () => {
    switch (code) {
      case 1:
        return (
          <span>低</span>
        );
      case 2:
        return (
          <span>中</span>
        );
      case 3:
        return (
          <span>高</span>
        );
      default:
        return (
          <span>該当なし</span>
        );
    }
  };

  return (
    <span className={classes.txt}>
      {getAction()}
    </span>
  );
}
